import React from "react";
import { connect } from "react-redux";
import AuthNavBar from "../../allauth/AuthNavBar";
import { withRouter } from "../../utils/withRouter";
import { setFocusedMembership } from "../../store/api/calls";
import { withAuth } from "../../allauth/auth/withHooks";
import { CardHeader, Typography } from "@mui/material";

class ProfileScreen extends React.Component {

  handleCampaignSelection = (id) => {
    setFocusedMembership(id);
  };

  listRoles(campaignId) {
    const roles = this.props.memberships.filter(m => m.campaign.id === campaignId).map(m => m.role.name.substring(0, 1).toUpperCase() + m.role.name.substring(1));
    return roles.join(', ');
  }

  renderActiveMemberships = () => {
    const allCampaigns = this.props.campaigns.map(campaign => {
      return <CardHeader item
        data-campaignid={campaign.id}
        key={`select-active-campaign-${campaign.id}`}
        title={campaign.name}
        subheader={<React.Fragment>
          <Typography variant="body2" >
            {this.listRoles(campaign.id)}
            <Typography variant="caption" style={{ marginLeft: '5px' }}  >
              - {new Date(campaign.created_at).toDateString()}
            </Typography>          
          </Typography>
          
        </React.Fragment>}
      />
    });

    if (allCampaigns.length === 0) {
      return <Typography variant="body1" color="text.secondary" >No active campaigns memberships found</Typography>
    }

    return <React.Fragment>
      <h5 className={"primary-text"} style={{ margin: '20px 0 0 0' }}>My Campaign Memberships</h5>
        {allCampaigns}
    </React.Fragment>
  }

  renderInactiveMemberships = () => {
    if (!this.props.memberships) return null;
    const inactiveCampaigns = [];
    for (const membership of this.props.memberships) {
      const campaign = membership.campaign;
      if (!campaign.is_active) {
        inactiveCampaigns.push(<CardHeader item
          data-campaignid={campaign.id}
          key={`inactive-campaign-${campaign.id}`}
          title={campaign.name}
          subheader={<React.Fragment>
          <Typography variant="body2" >
            {this.listRoles(campaign.id)}
            <Typography variant="caption" style={{ marginLeft: '5px' }}  >
              - {new Date(campaign.created_at).toDateString()} - (<span>Inactive #{campaign.id}</span>)
            </Typography>            
            </Typography>
          </React.Fragment>}
        />);
      }
    }
    
    if (inactiveCampaigns.length === 0) return null;

    return <React.Fragment>
      <h5 className={"primary-text"} style={{ margin: '20px 0 0 0' }}>My Inactive Campaign Memberships</h5>
        {inactiveCampaigns}
    </React.Fragment>
  }



  render() {
    return (
      <>
        <h5 className={"primary-text mb-1"}>Manage Profile</h5>
        <p style={{ margin: '0' }}>{this.props.user.username}</p>
        <p style={{ margin: '0 0 20px 0' }}>{this.props.user.email}</p>

        <AuthNavBar />


        {this.renderActiveMemberships()}
        {this.renderInactiveMemberships()}

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  memberships: state.permissions.memberships,
  campaigns: state.campaigns.data
});


export default connect(
  mapStateToProps,
  null
)(withRouter(withAuth(ProfileScreen)));